import { LDSButton, LDSDialog, LDSInputText } from "@resmed/lumina-design-system";
import { useState } from "react";
import floppyIcon from "../../../assets/floppy.svg";

export interface RenameGroupDialogProps {
  visible: boolean;
  currentName: string;
  onSave: (name: string) => void;
  onCancel: () => void;
}

const RenameGroupDialog = ({
  visible,
  currentName,
  onSave,
  onCancel,
}: RenameGroupDialogProps) => {
  const [name, setName] = useState(currentName);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    if (!name.trim() || isSaving) return;
    setIsSaving(true);
    onSave(name.trim());
  };

  return (
    <LDSDialog
      id="rename-group-dialog"
      headerTitle="Rename group"
      visible={visible}
      onHide={onCancel}
      dismissableMask
      closeOnEscape
      blockScroll
      fullScreenIcon={false}
      size="medium"
      rootClassName="lds-w-[90vw] lds-max-w-2xl"
      footer={
        <div className="lds-flex lds-gap-4">
          <LDSButton
            id="rename-group-save"
            label="Save"
            icon={floppyIcon}
            iconPos="left"
            severity="success"
            loading={isSaving}
            disabled={!name.trim() || name.trim() === currentName || isSaving}
            onClick={handleSave}
          />
          <LDSButton
            id="rename-group-cancel"
            label="Cancel"
            outlined
            severity="secondary"
            onClick={onCancel}
            disabled={isSaving}
          />
        </div>
      }
    >
      <LDSInputText
        id="rename-group-input"
        label="Group name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && name.trim() && !isSaving) handleSave(); }}
        rootClassName="lds-w-full"
      />
    </LDSDialog>
  );
};

export default RenameGroupDialog;
